import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import AppIcon from '../icon/AppIcon.vue'
import { IconSlug } from '@/v2/components/ui/icon/iconMap'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenuButton',
  props: {
  leadingIcon: null,
  trailingIcon: null,
  unfocusOnClick: { type: Boolean, default: true },
  mini: { type: Boolean, default: false },
  truncate: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
},
  emits: ["click", "mouseenter"],
  setup(__props, { emit }) {

const props = __props;





const buttonRef = ref<HTMLElement | null>(null)

function handleClick(event: MouseEvent) {
  if (props.unfocusOnClick) {
    buttonRef.value!.blur()
  }
  emit('click', event)
}

return { __sfc: true,props, emit, buttonRef, handleClick, AppIcon }
}

})